// extracted by mini-css-extract-plugin
export default {"container":"form-row_container__3z3aG","alwaysHorizontal":"form-row_alwaysHorizontal__xr2Og"};